import React from 'react';

export default (
  <svg viewBox='0 0 762.75 594.64'>
    <path
      className='cls-1'
      d='M382.26,17.13c-132,0-238.94,107-238.94,238.94S250.3,495,382.26,495,621.19,388,621.19,256.07,514.16,17.27,382.26,17.13ZM482.88,263.68a17,17,0,0,1-7.66,7.66v.09L338.69,339.69A17.06,17.06,0,0,1,314,324.33V187.8a17.07,17.07,0,0,1,24.7-15.27l136.53,68.26A17.06,17.06,0,0,1,482.88,263.68Z' />
  </svg>
);
